import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { environment } from '@environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryUrl,
  environment: environment.name,
});

const bootstrap = () => bootstrapApplication(AppComponent, appConfig);

bootstrap().catch(err => console.error('Bootstrap error', err));
